<template>
  <div id="cities" class="relativeItem">
    <div>
      <!--搜索框-->
      <div class="cshell">
        <div class="c conditionTop">
          <input type="text" placeholder="输入城市名或拼音" v-model="content">
        </div>
      </div>
      <!--热门城市-->
      <div class="hit" v-if="!showSearch">
        <p class="title" id="hit">热门城市</p>
        <ul class="o08rem flex-box">
          <li v-for="(n, index) in remen" :key="index" @click="close">{{ n.name_chs }}</li>
        </ul>
      </div>

      <!--城市列表-->
      <ul class="cityUl whiteB" v-if="!showSearch">
        <li v-for="(value, key) in city" :key="key">
          <p class="title" :id="key">{{ key }}</p>
          <ul>
            <li v-for="(n, xindex) in value" :key="xindex" @click="close">{{ n.name_chs }}</li>
          </ul>
        </li>
      </ul>
      <!--搜索出来的城市列表-->
      <ul class="cityUl whiteB" v-else>
        <li>
          <ul>
            <li v-for="(n, index) in search" :key="index" @click="close">{{ n.name_chs }}</li>
          </ul>
        </li>
      </ul>

      <!--右边定位按钮-->
      <ul class="right" v-if="!showSearch">
        <li class="relativeItem" @click="toTarget">热门</li>
        <li v-for="(n, index) in hit" :key="index" class="relativeItem" @click="toTarget">{{ n }}</li>
      </ul>
    </div>
  </div>
</template>

<script>
import cities from "../../utils/city";

export default {
  name: "cities",
  components: {},
  props: [],
  data() {
    return {
      content: "",
      showSearch: false,
      search: [], //通过搜索出来的城市列表
      overHeight: 0, //搜索框的高度
      hit: [],
      city: {},
      remen: []
    };
  },
  methods: {
    //通知父组件关闭城市选择
    close(e) {
      let text = e.target.innerText;
      this.$emit("closect",text);
    },
    /**跳到锚点位置 */
    toTarget(e) {
      if (e.target.innerText == "热门") {
        document.getElementById("hit").scrollIntoView() + this.overHeight;
      } else {
        document.getElementById(e.target.innerText).scrollIntoView() +
          this.overHeight;
      }
      let s = this.$tool.getByID("cities");
      s.scrollTop = s.scrollTop - 55; //需要减去搜索框的高度
    },
    /**获取城市信息 */
    getCity() {
      // let _this = this;
      // this.$jsonp(this.$apis("getCity", "app"), {}, res => {
      //   _this.city = res.data.data.data;
      //   for (const key in _this.city) {
      //     _this.hit.push(key);
      //   }
      //   _this.remen = res.data.data.hot;
      // });
      

      //改为从本地获取
      this.remen = cities.hot;
      this.city = cities.all;
      for (const key in this.city) {
        this.hit.push(key);
      }
    }
  },
  mounted: function() {
    this.getCity();
  },
  watch: {
    content() {
      this.search = [];
      let hanzi = /[\u4e00-\u9fa5]+/;
      if (this.content != "") {
        this.showSearch = true;
        if (hanzi.test(this.content)) {
          //通过城市名称查询
          for (const key in this.city) {
            this.city[key].forEach(e => {
              if (e.name_chs.indexOf(this.content) != -1) {
                this.search.push(e);
              }
            });
          }
        } else {
          //通过城市拼英查询
          for (const key in this.city) {
            this.city[key].forEach(e => {
              if (e.pinyin.indexOf(this.content) != -1) {
                this.search.push(e);
              }
            });
          }
        }
      } else {
        this.showSearch = false;
      }
    }
  }
};
</script>

<style scoped>
#cities {
  position: fixed;
  left: 0;
  top: 0;
  width: 100vw;
  height: 100vh;
  background: #f4f4f4;
  overflow-y: scroll;
  z-index: 5;
}
.cshell {
  height: 55px;
}
.c {
  width: 100%;
  background: #f4f4f4 !important;
}
.c * {
  vertical-align: middle;
}
.c input {
  width: 100%;
  margin-right: 3%;
  padding: 1rem 0;
  padding-left: 2.4rem;
  font-size: 16px;
  background: url("../../assets/search.png") no-repeat 0.8rem center #fff;
  background-size: 1.3rem;
  color: #999;
}

/*热门城市*/
.title {
  font-size: 14px;
  background: #ccc;
  padding: 0.3rem 0.8rem;
}
.hit ul {
  padding: 0.8rem;
  align-content: flex-start;
  flex-wrap: wrap;
  background: #fafafa;
}
.hit ul li {
  width: 32%;
  border: 1px solid #f4f4f4;
  font-size: 15px;
  text-align: center;
  padding: 0.4rem 0;
  background: #fefefe;
  margin-bottom: 0.5rem;
  margin-right: 2%;
}
.hit ul li:nth-child(3n) {
  margin-right: 0;
}

/*城市列表*/
.cityUl ul {
  padding: 0 0.8rem;
}
.cityUl ul li {
  padding: 0.9rem 0;
  font-size: 15px;
  border-bottom: 1px solid #f4f4f4;
}
.cityUl ul li:last-child {
  border-bottom: 0;
}
.right {
  position: fixed;
  right: 0.2rem;
  top: 28%;
  font-size: 12px;
  color: #666;
  text-align: center;
}
</style>
